// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__NppZU","input":"styles_input__2ovIE"};